import React from 'react'

import { DateSelector } from '@containers/DateSelector'
import { TabHeader } from '@containers/Headers/TabHeader'
import { ScreenContainer } from '@containers/ScreenContainer'
import { TaskList } from '@containers/Task'
import { WeekList } from '@containers/WeekList'

export function WeekView() {
  return (
    <ScreenContainer header={<TabHeader />}>
      <DateSelector />
      <WeekList />
      <TaskList />
    </ScreenContainer>
  )
}
